import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { heroContent, marketingImages } from '../../data/mock';

const Hero = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center pt-24 pb-16 overflow-hidden">
      {/* Floating 3D Shapes */}
      <div className="floating-shape shape-1"></div>
      <div className="floating-shape shape-2"></div>
      <div className="floating-shape shape-3"></div>
      <div className="floating-shape shape-4"></div>
      <div className="floating-ring ring-1"></div>
      <div className="floating-ring ring-2"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="glass-card-hero rounded-3xl p-6 md:p-12 lg:p-16 max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left Content */}
            <div className="text-left">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight leading-tight break-words">
                GOD HAS A PLAN
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl text-white/90 font-medium mb-3 break-words">
                {heroContent.headline}
              </p>
              <p className="text-base sm:text-lg text-white/70 mb-8 leading-relaxed break-words">
                {heroContent.description}
              </p>

              {/* CTA Button */}
              <Button 
                size="lg" 
                className="bg-white text-teal-600 hover:bg-white/90 text-base sm:text-lg md:text-xl font-bold px-6 sm:px-10 py-6 sm:py-7 rounded-xl shadow-2xl shadow-black/20 group w-full sm:w-auto"
              >
                {heroContent.cta}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>

              {/* Social Proof */}
              <p className="text-white/60 text-sm mt-6">
                {heroContent.socialProof}
              </p>
            </div>

            {/* Right Content - Book Mockup */}
            <div className="flex justify-center lg:justify-end order-first lg:order-last">
              <img 
                src={marketingImages.bookMockup} 
                alt="God Has A Plan - Ebook Guide"
                className="w-full max-w-xs sm:max-w-sm md:max-w-md rounded-2xl shadow-2xl shadow-black/30"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
